import { Router, NavigationEnd } from "@angular/router";
import { DOCUMENT } from "@angular/common";
import {
  Component,
  Inject,
  ElementRef,
  OnInit,
  Renderer2,
  HostListener,
  OnDestroy,
} from "@angular/core";
import { ROUTES } from "./sidebar-items";
import { AuthService } from "src/app/core/service/auth.service";
import { Role } from "src/app/core/models/role";
import { DomSanitizer } from "@angular/platform-browser";
import { AppService } from "src/app/core/service/app.service";
import { DmsDocument } from "src/app/shared/models/dms-document";
import { UserAccount } from "src/app/shared/models/user-account";
import PharmcistService from "src/app/pharmacist/pharmcist.service";
import { NgxSpinnerService } from "ngx-spinner";
@Component({
  selector: "app-sidebar",
  templateUrl: "./sidebar.component.html",
  styleUrls: ["./sidebar.component.sass"],
})
export class SidebarComponent implements OnInit, OnDestroy {
  public sidebarItems: any[];
  level1Menu = "";
  level2Menu = "";
  level3Menu = "";
  public innerHeight: any;
  public bodyTag: any;
  listMaxHeight: string;
  listMaxWidth: string;
  userFullName: string;
  userImg: string;
  userType: string;
  headerHeight = 60;
  currentRoute: string;
  routerObj = null;
  userAccount: UserAccount;
  dmsDocument: DmsDocument;
  pendingDoctorsCount: any;
  pharmacyProfile: any;
  constructor(
    @Inject(DOCUMENT) private document: Document,
    private renderer: Renderer2,
    public elementRef: ElementRef,
    private authService: AuthService,
    private router: Router,
    private appService: AppService,
    private sanitizer: DomSanitizer,
    private pharmacistService: PharmcistService,
    private spinner: NgxSpinnerService
  ) {
    const body = this.elementRef.nativeElement.closest("body");
    this.routerObj = this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        // logic for select active menu in dropdown
        const role = ["admin", "doctor", "patient"];
        const currenturl = event.url.split("?")[0];
        const firstString = currenturl.split("/").slice(1)[0];

        if (role.indexOf(firstString) !== -1) {
          this.level1Menu = event.url.split("/")[2];
          this.level2Menu = event.url.split("/")[3];
        } else {
          this.level1Menu = event.url.split("/")[1];
          this.level2Menu = event.url.split("/")[2];
        }

        // close sidebar on mobile screen after menu select
        this.renderer.removeClass(this.document.body, "overlay-open");
      }
    });
    this.userAccount = new UserAccount();
    this.dmsDocument = new DmsDocument();
    this.pharmacyProfile = null;
  }
  @HostListener("window:resize", ["$event"])
  windowResizecall(event) {
    this.setMenuHeight();
    this.checkStatuForResize(false);
  }
  @HostListener("document:mousedown", ["$event"])
  onGlobalClick(event): void {
    if (!this.elementRef.nativeElement.contains(event.target)) {
      this.renderer.removeClass(this.document.body, "overlay-open");
    }
  }
  callLevel1Toggle(event: any, element: any) {
    if (element === this.level1Menu) {
      this.level1Menu = "0";
    } else {
      this.level1Menu = element;
    }
    const hasClass = event.target.classList.contains("toggled");
    if (hasClass) {
      this.renderer.removeClass(event.target, "toggled");
    } else {
      this.renderer.addClass(event.target, "toggled");
    }
  }
  callLevel2Toggle(event: any, element: any) {
    if (element === this.level2Menu) {
      this.level2Menu = "0";
    } else {
      this.level2Menu = element;
    }
  }
  callLevel3Toggle(event: any, element: any) {
    if (element === this.level3Menu) {
      this.level3Menu = "0";
    } else {
      this.level3Menu = element;
    }
  }
  ngOnInit() {
    this.GetPharmacyById();
    this.pharmacistService.pendingDoctorsCount.subscribe({
      next: (resp: any) => {
        this.pendingDoctorsCount = resp;
        // if (this.userAccount.UserRoleId == 3) {
        if (this.sidebarItems != undefined) {
          this.sidebarItems.forEach((element) => {
            if (element.title === "DOCTORS") {
              element.badge =
                this.pendingDoctorsCount == 0 ? "" : this.pendingDoctorsCount;
              element.badgeClass =
                this.pendingDoctorsCount == 0
                  ? ""
                  : "badge bg-red sidebar-badge";
            }
          });
        }
        this.sidebarItems = Object.assign([], this.sidebarItems);
        // }
      },
      error: () => {
        this.spinner.hide();
      },
    });

    this.userAccount = JSON.parse(sessionStorage.getItem("CurrentUser"));
    if (this.userAccount) {
      const userRole = this.GetRole(this.userAccount.UserRoleId);

      this.sidebarItems = ROUTES.filter(
        (x) => x.role.indexOf(userRole) !== -1 || x.role.indexOf("All") !== -1
      );

      if (userRole === Role.Admin) {
        this.userType = Role.Admin;
      } else if (userRole === Role.Doctor) {
        this.userType = Role.Doctor;
      } else {
        this.userType = Role.Admin;
      }
    }

    // this.sidebarItems = ROUTES.filter((sidebarItem) => sidebarItem);
    this.initLeftSidebar();
    this.bodyTag = this.document.body;
    this.getProfilePicture(this.userAccount.ProfilePictureThumbId);
  }

  ngAfterViewInit() {}

  getProfilePicture(documentId) {
    const doc = { DocumentId: documentId };
    this.appService.getProfilePicture(doc).subscribe({
      next: (res: any) => {
        if (!res.HasErrors) {
          this.dmsDocument = res;
        } else {
          this.spinner.hide();
        }
      },
      error: () => {
        this.spinner.hide();
      },
    });
  }

  public getSantizeUrl(url: string) {
    return this.sanitizer.bypassSecurityTrustUrl(url);
  }

  ngOnDestroy() {
    this.routerObj.unsubscribe();
  }
  initLeftSidebar() {
    const _this = this;
    // Set menu height
    _this.setMenuHeight();
    _this.checkStatuForResize(true);
  }
  setMenuHeight() {
    this.innerHeight = window.innerHeight;
    const height = this.innerHeight - this.headerHeight;
    this.listMaxHeight = height + "";
    this.listMaxWidth = "500px";
  }
  isOpen() {
    return this.bodyTag.classList.contains("overlay-open");
  }
  checkStatuForResize(firstTime) {
    if (window.innerWidth < 1170) {
      this.renderer.addClass(this.document.body, "ls-closed");
    } else {
      this.renderer.removeClass(this.document.body, "ls-closed");
    }
  }
  mouseHover(e) {
    const body = this.elementRef.nativeElement.closest("body");
    if (body.classList.contains("submenu-closed")) {
      this.renderer.addClass(this.document.body, "side-closed-hover");
      this.renderer.removeClass(this.document.body, "submenu-closed");
    }
  }
  mouseOut(e) {
    const body = this.elementRef.nativeElement.closest("body");
    if (body.classList.contains("side-closed-hover")) {
      this.renderer.removeClass(this.document.body, "side-closed-hover");
      this.renderer.addClass(this.document.body, "submenu-closed");
    }
  }
  // logout() {
  //   this.authService.logout().subscribe((res) => {
  //     if (!res.success) {
  //       this.router.navigate(["/authentication/signin"]);
  //     }
  //   });
  // }
  GetRole(roleId) {
    if (roleId == 1) {
      return "Admin";
    } else if (roleId == 2) {
      return "Doctor";
    } else if (roleId == 3) {
      return "Pharmacist";
    } else if (roleId == 4) {
      return "PharmacySubAdmin";
    }
  }
  Logout() {
    this.authService.Logout(this.userAccount);
  }

  GetPharmacyById() {
    var pharmacyDetails = {
      Id: 1,
    };
    this.spinner.show();
    this.pharmacistService.GetPharmacyDetails(pharmacyDetails).subscribe({
      next: (resp: any) => {
        if (!resp.HasErrors) {
          this.pharmacyProfile = resp?.pharmacy;
          this.spinner.hide();
        }
        this.spinner.hide();
      },
      error: () => {
        this.spinner.hide();
      },
    });
  }
}
